import React from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
const CountDownTimer = (props) => {
    const timerProps = {
        isPlaying: true,
        size: 80,
        strokeWidth: 6,
    };
    return (React.createElement("div", { className: "d-flex align-items-center justify-content-center timerspan mgt-15" },
        React.createElement(CountdownCircleTimer, Object.assign({}, timerProps, { isPlaying: true, duration: props.duration ? props.duration : 120, colors: "#51B255", onComplete: () => console.log("times up"), onUpdate: (rem) => { props.onTimerUpdate(rem); } }), ({ remainingTime }) => "" + Math.floor(remainingTime / 60) + ":" + (remainingTime % 60) + "")));
};
export default CountDownTimer;
